import login_bgImg from "./login_bg.png";
import logoImg from "./logo.png";
import upcitiLogoImg from "./upciti_logo.png";

const images = {
  login_bg: login_bgImg,
  logo: logoImg,
  upcitiLogo: upcitiLogoImg,
};

export default images;
